import type { BulkField } from '../types'

type BulkTimeWindow = BulkField<uui.domain.rm.TimeWindow[]>

export function compareTimeWindows(
  bulkValue: BulkTimeWindow,
  orderValue: uui.domain.rm.TimeWindow[],
): BulkTimeWindow {
  if (bulkValue === 'mixed') return bulkValue

  if (bulkValue.length !== orderValue.length) {
    return 'mixed'
  }

  const [s1, s2] = bulkValue
  const [tw1, tw2] = orderValue

  if (!isSameTimeWindow(s1, tw1)) return 'mixed'
  if (!isSameTimeWindow(s2, tw2)) return 'mixed'

  return bulkValue
}

function isSameTimeWindow(tw1?: uui.domain.rm.TimeWindow, tw2?: uui.domain.rm.TimeWindow): boolean {
  if (!tw1 && !tw2) return true

  // One is undefined/null, the other is not
  if (!tw1 || !tw2) return false

  return tw1.startSec === tw2.startSec && tw1.endSec === tw2.endSec
}
